import { LifeRingTrigger } from 'components/ActionBar/LifeRing/LifeRingButton/LifeRingButton';
import { ConnectedHelpCenterButton } from 'components/shared/HelpCenter/HelpCenterButton';
import { useToggleFeature } from 'hooks/useToggleFeature';
import type { ReactNode } from 'react';
import { ModalFooter } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { type TypedError, useTypedErrorMessage } from 'utils/errors/errors';

interface OwnProps {
  cancelBtn: ReactNode;
  validateBtn: ReactNode;

  hasHelpBtn: boolean;

  modalId: string;
  error?: TypedError;
}

interface Props extends OwnProps {}

export function ScheduledRunModalFooter({ hasHelpBtn, cancelBtn, validateBtn, modalId, error }: Props) {
  const txt = useTypedErrorMessage(error);
  const isEnabled = useToggleFeature('helpCenterEnhancement');
  const helpBtn = isEnabled ? (
    <div className="d-flex w-100 justify-content-end">
      <div>
        <ConnectedHelpCenterButton helpCenterId={ScheduledRunModalFooter.name} defaultMessage={txt} />
      </div>
    </div>
  ) : (
    <LifeRingTrigger
      defaultMessage={txt}
      e2e="scheduled-run-contact-us-button"
      className="d-flex w-100"
      shouldIgnoreElementOverride={el => el.querySelector(`[id="${modalId}"]`) === null}
    >
      <button type="button" className="btn btn-outline btn-outline-secondary text-primary d-flex flex-grow-1 ">
        <FormattedMessage id="lifeRing.helpRequest" />
        <em className="icon icon-outlined ms-1">live_help</em>
      </button>
    </LifeRingTrigger>
  );
  return (
    <ModalFooter className="d-flex flex-wrap pt-2">
      {hasHelpBtn && helpBtn}
      <div className="d-flex flex-grow-1 justify-content-around">
        {cancelBtn}
        {validateBtn}
      </div>
    </ModalFooter>
  );
}
